var _path, _path2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.69502 16.2887C1.91477 17.6318 3.05597 18.6571 4.4131 18.7583C6.21611 18.8929 8.0838 19.0332 9.99721 19.0332C11.9106 19.0332 13.7783 18.8929 15.5813 18.7583C16.9385 18.6571 18.0796 17.6318 18.2994 16.2887C18.4472 15.3855 18.5686 14.4595 18.5686 13.5161C18.5686 12.5728 18.4472 11.6467 18.2994 10.7435C18.0796 9.40048 16.9385 8.37519 15.5813 8.27392C13.7783 8.13938 11.9106 7.99902 9.99721 7.99902C8.0838 7.99902 6.21611 8.13937 4.4131 8.27392C3.05596 8.37519 1.91477 9.40048 1.69502 10.7435C1.54723 11.6467 1.42578 12.5728 1.42578 13.5161C1.42578 14.4595 1.54723 15.3855 1.69502 16.2887Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 1.43
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 1.96729L9.99609 7.99884",
    stroke: "#84C70D",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.35792,
    cy: 13.5161,
    r: 2.05714,
    fill: "#0A0C13",
    stroke: "#84C70D",
    strokeWidth: 1.43
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6392,
    cy: 13.5161,
    r: 2.05714,
    fill: "#0A0C13",
    stroke: "#84C70D",
    strokeWidth: 1.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.4cac723bcab304596a52415d27aea811.svg";
export { ForwardRef as ReactComponent };